export const AvailableIconSizes = ['medium', 'large', 'extra-large', 'enormous'];

export const IconSizes = ['small', 'small-medium', ...AvailableIconSizes];

export const KnowFileExtensions = [
  'bmp',
  'csv',
  'doc',
  'docx',
  // 'folder',
  'jpg',
  'ods',
  'pdf',
  'png',
  'ppt',
  'rar',
  'rtf',
  'sig',
  'txt',
  // 'unknown',
  'xlsx',
  'xml',
  'zip',
];
